<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="false"
  [breakpoints]="REA_DIALOG_BREAKPOINTS"
  (onShow)="getLastRegisterREA()"
  [style]="{ width: '46vw' }"
  styleClass="rea-dialog"
  id="export-rea-dialog"
>
  <ng-template pTemplate="header">
    <div class="rea-header">
      <div class="rea-header__title">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Importar REA</span>
      </div>

      @if (historicoREA?.isOk) {
        <p-tag
          [value]="'Última Importación: ' + lastReaFecha"
          severity="info"
          [rounded]="true"
          class="rea-badge"
        ></p-tag>
      }

      @if (historicoREA?.isCreated) {
        <p-tag
          value="Nueva importación"
          severity="success"
          [rounded]="true"
          class="rea-badge"
        ></p-tag>
      }
    </div>
  </ng-template>

  <div class="rea-body">
    <p-card class="rea-card">
      <div class="grid rea-row">
        <div class="col-12 md:col-6">
          <label class="rea-label">Código REA</label>
          <p class="rea-value">{{ model.codigo_REA ?? '-' }}</p>
        </div>
        <div class="col-12 md:col-6">
          <label class="rea-label">NIF</label>
          <p class="rea-value">{{ model.titular_nif ?? '-' }}</p>
        </div>
      </div>

      @if (showSpinner) {
        <div class="rea-spinner">
          <p-progress-spinner strokeWidth="6" animationDuration="1.2s"></p-progress-spinner>
        </div>
      }

      @if (importResult?.isAccepted) {
        <div class="rea-row">
          <p-card>
            <h4 class="mb-2">Detalle de importación</h4>

            @if (importSummary) {
              <div class="grid">
                <div class="col-12 md:col-6"><p>Parcelas no insertadas: <b>{{ importSummary.parcelasNoInsertadas }}</b></p></div>
                <div class="col-12 md:col-6"><p>Parcelas insertadas: <b>{{ importSummary.parcelasInsertadas }}</b></p></div>
                <div class="col-12 md:col-6"><p>Parcelas no actualizadas: <b>{{ importSummary.parcelasNoActualizadas }}</b></p></div>
                <div class="col-12 md:col-6"><p>Parcelas actualizadas: <b>{{ importSummary.parcelasActualizadas }}</b></p></div>
              </div>              
            }
          </p-card>
        </div>
      }

      <div class="rea-row">
        @switch (messageState) {
          @case ('warning') {
            <p-message severity="warn" text="Faltan datos para exportar REA"></p-message>
          }
          @case ('error') {
            <p-message severity="error" [text]="importResult?.statusMessage"></p-message>
          }
          @case ('success') {
            <p-message severity="success" [text]="importResult?.statusMessage"></p-message>
          }
        }
      </div>
    </p-card>
  </div>

  <ng-template pTemplate="footer">
    <div class="rea-footer">
      <p-button
        label="{{ importResult?.statusCode ? 'Volver' : 'Cancelar' }}"
        severity="secondary"
        [fluid]="true"
        (onClick)="hide()">
      </p-button>

      <!-- Only show "Enviar" before receiving a response -->
      @if (canSend) {
        <p-button
          type="button"
          label="Enviar"
          [disabled]="isReaDisabled"
          [loading]="showSpinner"
          severity="success"
          [fluid]="true"
          (onClick)="exportREA()">
        </p-button>
      }
    </div>
  </ng-template>
</p-dialog>
